import React from 'react';

const footerLinks = {
  Services: [
    'Network Infrastructure',
    'Custom Software',
    'Cloud Computing',
    'Cybersecurity',
    'Business Intelligence',
    'IoT & Automation',
  ],
  Sectors: [
    'Mining & Extraction',
    'Oil & Gas',
    'Telecommunications',
    'Energy & Utilities',
    'Industrial Supply Chain',
    'Enterprise & Corporate',
  ],
  Company: [
    'Why ADELZONE',
    'How We Work',
    'Contact Us',
    'Get a Quote',
    'Technology Partnerships',
  ],
};

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer style={{
      background: '#060F1C',
      padding: '4rem 5% 2rem',
      borderTop: '1px solid rgba(0,180,216,0.1)',
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '3rem',
        marginBottom: '3rem',
      }}>
        {/* Brand */}
        <div style={{ gridColumn: 'span 1' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.3rem', fontWeight: 700, color: 'var(--white)', marginBottom: '0.8rem' }}>
            ADEL<span style={{ color: 'var(--electric)' }}>ZONE</span> LTD
          </div>
          <div style={{ fontSize: '0.85rem', color: 'var(--slate)', lineHeight: 1.65, maxWidth: '260px' }}>
            Enterprise IT infrastructure, network connectivity, and custom software architecture for Ghana's most demanding industries. Accra-based. West Africa–focused. International-standard.
          </div>
          <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.6rem', flexWrap: 'wrap' }}>
            {['Mining', 'Oil & Gas', 'IoT', 'Cloud'].map(tag => (
              <span key={tag} style={{
                fontSize: '0.68rem', fontWeight: 600,
                background: 'rgba(0,180,216,0.08)', color: 'var(--electric)',
                border: '1px solid rgba(0,180,216,0.15)',
                padding: '0.2rem 0.55rem', borderRadius: '4px',
              }}>{tag}</span>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {Object.entries(footerLinks).map(([col, links]) => (
          <div key={col}>
            <div style={{ fontSize: '0.73rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--white)', marginBottom: '1rem' }}>
              {col}
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {links.map(link => (
                <li key={link}>
                  <button
                    onClick={() => scrollTo(col === 'Company' ? 'why' : col.toLowerCase())}
                    style={{
                      background: 'none', border: 'none',
                      color: 'var(--slate)', fontSize: '0.85rem',
                      cursor: 'pointer', padding: 0, textAlign: 'left',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={e => e.target.style.color='var(--electric)'}
                    onMouseLeave={e => e.target.style.color='var(--slate)'}>
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div style={{
        paddingTop: '1.5rem',
        borderTop: '1px solid rgba(0,180,216,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '0.8rem',
      }}>
        <div style={{ fontSize: '0.8rem', color: 'var(--slate)' }}>
          © {new Date().getFullYear()} ADELZONE LTD. All rights reserved. Accra, Ghana.
        </div>
        <div style={{ fontSize: '0.8rem', color: 'var(--slate)' }}>
          Built for <span style={{ color: 'var(--electric)' }}>West Africa's digital future</span>
        </div>
      </div>
    </footer>
  );
}
